import { CURRENCY_COOKIE_NAME, DEFAULT_CURRENCY, parseCustomerCurrency, type CustomerCurrency } from '@/config/currency';
import { readBrowserCurrencyCookie } from '@/lib/currency/browser-cookie';

/**
 * Resolves the customer currency for the current request runtime.
 * - Browser: reads `fe_currency` from document.cookie
 * - Server: reads `fe_currency` via next/headers cookies()
 */
export async function getRequestCurrency(): Promise<CustomerCurrency> {
  if (typeof window !== 'undefined') {
    return readBrowserCurrencyCookie();
  }

  try {
    const { cookies } = await import('next/headers');
    return parseCustomerCurrency(cookies().get(CURRENCY_COOKIE_NAME)?.value);
  } catch {
    return DEFAULT_CURRENCY;
  }
}
